import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { IChatConversationIsTypingChangedEventData } from '@fi-shared/fi-signal-r/fi-signal-r';
import { FiProfileSizes } from '@fi-shared/profile-icon/profile-icon.component';

@Component({
    selector: 'fi-chat-conversation-typing-indicator',
    template: `
        @for (typingMessage of conversationUsersTypingData; track typingMessage) {
          <div class="typing-indicator-wrapper">
            <fi-profile-icon
              [size]="fiProfileSizes.Size28px"
              [profileData]="typingMessage.UserProfile"
              [hideConnectedInfo]="true"
              />
              <div class="message-data-wrapper">
                <p class="user-typing-data">
                  {{ typingMessage.UserProfile.FullName }} &#183;
                  {{ typingMessage.IsTypingChangedOn | fiFormatDate: 'time' }}
                </p>
                <fi-dot-loader loaderSize="small" />
              </div>
            </div>
          }
        `,
    styleUrl: './fi-chat-conversation-typing-indicator.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-chat-conversation-typing-indicator' },
    standalone: false,
})
export class FiChatConversationTypingIndicatorComponent {
    @Input() conversationUsersTypingData: IChatConversationIsTypingChangedEventData[] = [];
    protected readonly fiProfileSizes = FiProfileSizes;
}
